export default __webpack_public_path__ + "static/media/users.772c9a3f.svg";